export { default } from './DocumentComponent';
